export default "__VITE_ASSET__d41a2a89__"